<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
export default {
  components: {},
  data() {
    return {
      feedback_content: null,
      imgs:[],
    };
  },
  computed: {
    view_imgs_url(){
      var mul = [];
      this.imgs.forEach((r,index)=>{
        var mm = this.$glf.dealImg(r.url, null)
        mul.push({url:mm});
      });
      return mul; 
    },
  },
  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    //上传图片[兼容单图 or 多图]
    async afterReadImages(e) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      if(Object.prototype.toString.call(e)==='[object Array]'){
        //多图上传
        for(var i=0;i<e.length;i++){
          await this.$api.upload({ file: e[i].file }).then((res) => {
            this.imgs.push({url:res.data});
          });
        }
      }else{
        //单图上传
        await this.$api.upload({ file: e.file }).then((res) => {
          this.imgs.push({url:res.data});
        });
      }
      this.$toast("上传成功");
    },
    //限制图片大小
    onOversizeImages(file) {
      this.$toast("图片最大支持2M");
    },
    //删除图片
    beforeDeleteImages(file, detail) {
      this.imgs.splice(detail.index, 1);
    },
    //格式校验
    beforeReadImages(file){
      var check = true;
      if(Object.prototype.toString.call(file)==='[object Array]'){
        //多图上传
        for(var i=0;i<file.length;i++){
          if (['image/jpeg','image/png','image/gif'].indexOf(file[0].type) === -1) {
            if(check===true){
              check = '第'+(i+1)+'张图片格式错误';
            }
          }
        }
      }else{
        //单图上传
        if (['image/jpeg','image/png','image/gif'].indexOf(file.type) === -1) {
          if(check===true){
            check = '图片格式错误';
          }
        }
      }
      if(check!==true){
        this.$toast(check);
        return false;
      }else{
        return true;
      }
    },

    //提交信息
    onSub(){
      if(this.$glf.isEmpty(this.feedback_content)){
        this.$toast('反馈内容不能为空');
        return false;
      }
      if(this.$glf.isEmpty(this.imgs)){
        this.$toast('相关照片不能为空');
        return false;
      }
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      var params = {
        feedback:{
          content: this.feedback_content,
        },
        imgs: this.imgs
      };
      this.$api.feedbackAdd(params).then(res=>{
        this.$toast('提交成功');
        this.feedback_content = null;
        this.imgs = [];
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/advice/index.vue